<template>
  <div>
    <v-container fluid class="pa-4">
      <div class="d-flex">
        <span class="headline primary--text font-weight-medium">
          <v-icon class="primary--text" left>mdi-package-variant-closed</v-icon
          >Voyage Cargo
        </span>
        <v-spacer></v-spacer>
        <!-- Dummy View Switch -->
        <v-switch v-model="testView" label="Toggle Test View"></v-switch>
      </div>
      <v-container>
        <div v-if="!ecargoDataLoading || testView">
          <div v-if="inbound || outbound || testView">
            <v-tabs v-model="tab" icons-and-text>
              <v-tabs-slider></v-tabs-slider>

              <v-tab
                href="#outbound"
                v-if="outbound || (testView && dummyData.outbound)"
              >
                Outbound
                <span>
                  <v-icon right>mdi-ferry</v-icon>
                  <v-icon right>mdi-arrow-left</v-icon>
                </span>
              </v-tab>

              <v-tab
                href="#inbound"
                v-if="inbound || (testView && dummyData.inbound)"
              >
                Inbound
                <span>
                  <v-icon right>mdi-ferry</v-icon>
                  <v-icon right>mdi-arrow-right</v-icon>
                </span>
              </v-tab>
            </v-tabs>

            <div v-if="testView"></div>

            <v-tabs-items v-model="tab">
              <v-tab-item value="outbound">
                <VoyageCargoCardNew
                  direction="Outbound"
                  :voyageData="!testView ? outbound : dummyData.outbound"
                  barColour="blue"
                />
              </v-tab-item>

              <v-tab-item value="inbound" class="">
                <VoyageCargoCardNew
                  direction="Inbound"
                  :voyageData="!testView ? inbound : dummyData.inbound"
                  barColour="red"
                />
              </v-tab-item>
            </v-tabs-items>
          </div>

          <v-row v-else-if="ecargoVoyage" class="pa-4" justify="center">
            <v-alert outlined type="warning"> No Cargo Found </v-alert>
          </v-row>

          <v-row v-else class="pa-4" justify="center">
            <v-alert outlined type="error">
              Failed not connect to external system
            </v-alert>
          </v-row>
        </div>
        <v-row v-else justify="center">
          <v-progress-circular
            color="primary"
            indeterminate
          ></v-progress-circular>
        </v-row>
      </v-container>
    </v-container>
  </div>
</template>

<script>
import VoyageCargoCardNew from './VoyageCargoCardNew.vue';
import dummyRequestData from '../../dummy_data/eCargoVoyageRequestResult.json';

export default {
  name: 'VoyageCargo',
  props: {
    ecargoVoyage: Object,
    ecargoDataLoading: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    VoyageCargoCardNew,
  },
  data() {
    return {
      tab: '',
      testView: false,
      dummyData: dummyRequestData,
    };
  },
  computed: {
    outbound() {
      return this.ecargoVoyage ? this.ecargoVoyage.outbound : null;
    },
    inbound() {
      return this.ecargoVoyage ? this.ecargoVoyage.inbound : null;
    },
  },
};
</script>

<style scoped>
.overview-container {
  display: block;
  align-items: center;
}

.overview-container div {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  max-width: 500px;
  margin: 8px auto;
  align-self: center;
  text-align: right;
}

@media only screen and (min-width: 1264px) {
  .overview-container {
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    font-size: 18px;
  }
}
</style>
